// "How loaded is this reviewer" as one visual language app-wide.
//
// These thresholds were duplicated: TeamPanel.js owned them, and
// analytics/chartTheme.js copied them with a comment saying so outright
// ("copied verbatim from TeamPanel.js's TeamMember"). Two copies of a scale
// that is supposed to make the same person read the same way on two screens
// is exactly the kind of thing that drifts silently — the dashboard says
// "busy" in orange while the analytics chart still says teal. Same fix as
// utils/planStatus.js: one source of truth, each component keeps its own
// presentation.
//
// Raw hex rather than Tailwind class names, deliberately: chartTheme feeds
// Recharts, which renders raw SVG and cannot take class names.

export const LOAD_COLORS = {
  heavy: "#ff4757", // rf-accent-danger
  medium: "#ffa502", // rf-accent-warning
  light: "#00d4aa", // rf-accent
  // Not a load level. This is "we do not know", and it must not look like
  // "idle" — rendering an unknown count in the light-load teal is precisely
  // the false-confidence bug this whole change exists to remove.
  //
  // ⚠️ This was rf-text-muted (#4a5568) and had to change: measured against
  // the card background rf-bg-secondary (#151b2e) it is only 2.27:1, well
  // under WCAG AA's 4.5:1. It is the colour of the "—" unknown state AND the
  // "not routed" tag — so the two things this panel exists to say honestly
  // were the least legible text on the card. rf-text-secondary measures
  // 5.69:1. Re-measure before changing it again; every other colour used
  // here already passes (load colours 5.12-8.96:1).
  unknown: "#8b95ab", // rf-text-secondary
};

export const LOAD_THRESHOLD_HEAVY = 4;
export const LOAD_THRESHOLD_MEDIUM = 2;

/**
 * Colour for a reviewer's active-review count.
 *
 * Pass a non-number (null/undefined) when the count is genuinely unknown —
 * e.g. the team fetch failed, or the API is older than this build and never
 * sent the field. That returns the muted colour rather than defaulting to
 * light, so "unknown" and "free" stay visually distinct.
 */
export function loadColor(count) {
  if (typeof count !== "number" || Number.isNaN(count)) return LOAD_COLORS.unknown;
  if (count >= LOAD_THRESHOLD_HEAVY) return LOAD_COLORS.heavy;
  if (count >= LOAD_THRESHOLD_MEDIUM) return LOAD_COLORS.medium;
  return LOAD_COLORS.light;
}
